import { render, staticRenderFns } from "./ConfirmChangePlan.vue?vue&type=template&id=799b433e&scoped=true&"
import script from "./ConfirmChangePlan.vue?vue&type=script&lang=js&"
export * from "./ConfirmChangePlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799b433e",
  null
  
)

export default component.exports